<template>
  <el-dialog
    :title="isNew ? '新增参数' : '修改参数'"
    :visible="formVisible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="cancelForm"
  >
    <el-form
      v-loading="saveLoading"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="唯一标识" prop="afid">
        <product-select
          style="width: 100%"
          :value.sync="ruleForm.afid"
          :apiName="getParamProductList"
          :isDefault="false"
          :clearable="true"
          placeholder="请选择唯一标识"
          :disabled="!isNew"
          popper-class="BI-select BI-select-product"
        ></product-select>
      </el-form-item>
      <el-form-item v-if="paraType === 'meta'" label="数据集ID" prop="datasetId">
        <el-input type="text" v-model.trim="ruleForm.datasetId" placeholder="请输入数据集ID"></el-input>
      </el-form-item>
      <el-form-item v-if="paraType === 'meta'" label="Token" prop="token">
        <el-input type="text" v-model.trim="ruleForm.token" placeholder="请输入Token"></el-input>
      </el-form-item>
      <el-form-item v-if="paraType === 'firebase'" label="API Key" prop="apiKey">
        <el-input type="text" v-model.trim="ruleForm.apiKey" placeholder="请输入API Key"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="saveLoading" @click="cancelForm">取 消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="saveForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addPlatformConfig, getProductAfidListFetch, updatePlatformConfig } from "@/api/api.js";

const PLATFORM_TYPE_MAP = {
  meta: 1,
  firebase: 2,
};

export default {
  name: "platformParaDialog",
  props: {
    paraType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isNew: true,
      formVisible: false,
      ruleForm: this.getEmptyForm(),
      id: null,
      saveLoading: false,
    };
  },
  computed: {
    rules() {
      const rules = {
        afid: [{ required: true, message: "请选择唯一标识", trigger: "change" }],
      };
      if (this.paraType === "meta") {
        rules.datasetId = [{ required: true, message: "请输入数据集ID", trigger: "blur" }];
        rules.token = [{ required: true, message: "请输入Token", trigger: "blur" }];
      } else {
        rules.apiKey = [{ required: true, message: "请输入API Key", trigger: "blur" }];
      }
      return rules;
    },
  },
  methods: {
    getEmptyForm() {
      return {
        afid: "",
        datasetId: "",
        token: "",
        apiKey: "",
      };
    },
    async getParamProductList(params = {}) {
      const res = await getProductAfidListFetch(params);
      return {
        ...res,
        products: (res.products || []).map((item) => ({
          ...item,
          storeName: item.storeName || item.pkg || item.packageName || item.package_name || "",
        })),
      };
    },
    showModal(isNew, row) {
      this.saveLoading = false;
      this.isNew = isNew;
      this.id = row ? row.id : null;
      this.ruleForm = isNew
        ? this.getEmptyForm()
        : {
            afid: row.afid,
            datasetId: row.datasetId || "",
            token: row.token || "",
            apiKey: row.apiKey || "",
          };
      this.formVisible = true;
    },
    cancelForm() {
      if (this.saveLoading) {
        return;
      }
      this.formVisible = false;
    },
    saveForm() {
      if (this.saveLoading) {
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const param = {
          afid: this.ruleForm.afid,
          apiKey: this.paraType === "firebase" ? this.ruleForm.apiKey : "",
          datasetId: this.paraType === "meta" ? this.ruleForm.datasetId : "",
          id: this.isNew ? 0 : this.id,
          platformType: PLATFORM_TYPE_MAP[this.paraType],
          token: this.paraType === "meta" ? this.ruleForm.token : "",
        };
        const request = this.isNew ? addPlatformConfig(param) : updatePlatformConfig(param);
        this.saveLoading = true;
        request
          .then((res) => this.handleSaveResult(res))
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    handleSaveResult(res) {
      if (res.code === "0000") {
        this.$message.success(this.isNew ? "新建成功" : "修改成功");
        this.formVisible = false;
        this.$emit("updateTable");
      }
    },
  },
};
</script>
